export const INDUSTRIES = [
  {
    slug: "healthcare",
    name: "Healthcare",
    icon: "Stethoscope",
    summary: "Streamline workflows and strengthen security while keeping patient care first.",
    challenges: [
      "Workflow and scheduling inefficiency",
      "Cybersecurity and patient-data concerns",
      "Fragmented practice management systems",
    ],
  },
  {
    slug: "professional-services",
    name: "Professional Services",
    icon: "Briefcase",
    summary: "Improve client onboarding, delivery, and visibility across your engagements.",
    challenges: [
      "Inconsistent client onboarding",
      "Manual time and project tracking",
      "Limited visibility into utilization and margins",
    ],
  },
  {
    slug: "retail-distribution",
    name: "Retail & Distribution",
    icon: "ShoppingCart",
    summary: "Connect sales, inventory, and fulfillment for cleaner data and faster decisions.",
    challenges: [
      "Disconnected sales and inventory systems",
      "Limited visibility into stock and demand",
      "Manual order and fulfillment processes",
    ],
  },
  {
    slug: "manufacturing-operations",
    name: "Manufacturing & Operations",
    icon: "Factory",
    summary: "Bring clarity to ERP, reporting, and operations on the plant floor.",
    challenges: [
      "ERP and reporting limitations",
      "Disconnected production and inventory data",
      "Limited operational visibility",
    ],
  },
  {
    slug: "construction-field-services",
    name: "Construction & Field Services",
    icon: "HardHat",
    summary: "Connect the field and the office with technology that fits how crews work.",
    challenges: [
      "Field-to-office communication gaps",
      "Disconnected project and accounting systems",
      "Manual, paper-based job tracking",
    ],
  },
  {
    slug: "legal-services",
    name: "Legal Services",
    icon: "Scale",
    summary: "Modernize document workflows while protecting confidentiality.",
    challenges: [
      "Document workflow and version control",
      "Client confidentiality and security",
      "Manual, time-intensive processes",
    ],
  },
  {
    slug: "financial-services-insurance",
    name: "Financial Services & Insurance",
    icon: "Landmark",
    summary: "Balance efficiency, compliance, and security with confidence.",
    challenges: [
      "Regulatory and compliance pressure",
      "Data security and risk management",
      "Legacy systems limiting growth",
    ],
  },
  {
    slug: "architecture-engineering",
    name: "Architecture & Engineering",
    icon: "Ruler",
    summary: "Coordinate projects, files, and teams without losing momentum.",
    challenges: [
      "Large file and project coordination",
      "Collaboration across teams and partners",
      "Project profitability visibility",
    ],
  },
  {
    slug: "nonprofits",
    name: "Nonprofits",
    icon: "HeartHandshake",
    summary: "Do more with limited resources through practical, affordable technology.",
    challenges: [
      "Limited budgets and technical staff",
      "Donor and program data management",
      "Reporting for boards and funders",
    ],
  },
  {
    slug: "regulated-compliance",
    name: "Regulated & Compliance-Sensitive",
    icon: "FileCheck",
    summary: "Meet compliance demands while keeping systems efficient and secure.",
    challenges: [
      "Evolving compliance requirements",
      "Audit readiness and documentation",
      "Security across sensitive workflows",
    ],
  },
];
